Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addComponent = addComponent;
exports.removeComponent = removeComponent;
exports.watchComponent = watchComponent;

var _constants = require('../constants');

var _query = require('./query');

function addComponentToList(component) {
  return {
    type: _constants.ADD_COMPONENT,
    component: component
  };
}

function addComponentTimestamp(component, timestamp) {
  return {
    type: _constants.SET_REGISTERED_COMPONENT_TIMESTAMP,
    component: component,
    timestamp: timestamp
  };
}

function addComponent(component, timestamp) {
  return function (dispatch) {
    dispatch(addComponentToList(component));
    dispatch(addComponentTimestamp(component, timestamp));
  };
}

function removeComponent(component) {
  return {
    type: _constants.REMOVE_COMPONENT,
    component: component
  };
}

function updateWatchman(component, react) {
  return {
    type: _constants.WATCH_COMPONENT,
    component: component,
    react: react
  };
}

function watchComponent(component, react) {
  var execute = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return function (dispatch) {
    dispatch(updateWatchman(component, react));
    if (execute) dispatch((0, _query.executeQuery)(component));
  };
}